import React, { useContext, useEffect, useState } from 'react';
import { View, StyleSheet } from 'react-native';
import { translate } from '../../services/translate';
import FormInput from '../../components/formInput';
import FormActions from '../../components/formActions';
import ThemeContext from '../../context/Theme';
import getThemedColor from '../../services/get-themed-color';
import { WindowInformation } from '../../services/window-information';
import { dispatchService } from '../../services/central-api/dispatch';
import Toast from 'react-native-toast-message';
import { ClientError } from '../../services/central-api/base-service';

export default function AssignmentModal({ onClose, assignmentId: assignmentId }: { onClose: () => void, assignmentId?: number; }) {
    const { theme } = useContext(ThemeContext);
    const styles = getStyles(theme);
    const windowInfo = WindowInformation();

    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    async function getAssignment(id: number) {
        const assignment = await dispatchService.getAssignment(id);
        setName(assignment.name);
        setDescription(assignment.description);
    }

    async function loadPageInfo() {
        try {
            if (assignmentId) {
                await getAssignment(assignmentId);
            }
        } catch (err) {
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    useEffect(() => {
        loadPageInfo();
    }, []);

    function isEmpty(value: string) {
        return value.trim() == '';
    }

    function isFormValid() {
        return !isEmpty(name);
    }

    async function formSubmit() {
        try {
            if (assignmentId) {
                await dispatchService.updateAssignment(assignmentId, {
                    name,
                    description
                });
            } else {
                await dispatchService.createAssignment({ name, description });
            }

            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });

            onClose();
        } catch (err) {
            if (err instanceof ClientError) {
                return Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
            }

            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    return (
        <View style={[styles.formContainer, windowInfo.isMobile ? { width: '95%' } : { width: 635 }]}>
            <FormInput
                label={translate('name')}
                placeholder={translate('name')}
                value={name}
                onChangeText={setName}
                invalid={isEmpty}
            />
            <FormInput
                label={translate('description')}
                placeholder={translate('description')}
                multiline={true}
                numberOfLines={2}
                value={description}
                onChangeText={setDescription}
                invalid={() => false}
            />
            <FormActions
                onSubmit={formSubmit}
                onClose={onClose}
                disabled={!isFormValid()} />
        </View >
    );
}

function getStyles(theme: Theme) {
    return StyleSheet.create({
        formContainer: {
            minWidth: 300,
            backgroundColor: getThemedColor(theme, '#FFFFFF'),
            borderRadius: 2,
            padding: 20,
            justifyContent: 'space-between',
            rowGap: 10,
        },
    });
}
